import {
  TEMPLATE_CREATE_MAIL_TEMPLATE_BEGIN,
  TEMPLATE_CREATE_MAIL_TEMPLATE_SUCCESS,
  TEMPLATE_CREATE_MAIL_TEMPLATE_FAILURE,
  TEMPLATE_CREATE_MAIL_TEMPLATE_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function createMailTemplate(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: TEMPLATE_CREATE_MAIL_TEMPLATE_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates`,
        args.values,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: TEMPLATE_CREATE_MAIL_TEMPLATE_SUCCESS,
              data: res,
            });
            toast.success('Saved Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: TEMPLATE_CREATE_MAIL_TEMPLATE_FAILURE,
              data: { error: 'Failed' },
            });
            let errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: TEMPLATE_CREATE_MAIL_TEMPLATE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateMailTemplateError() {
  return {
    type: TEMPLATE_CREATE_MAIL_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_CREATE_MAIL_TEMPLATE_BEGIN:
      return {
        ...state,
        createMailTemplatePending: true,
        createMailTemplateError: null,
      };

    case TEMPLATE_CREATE_MAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        createMailTemplatePending: false,
        createMailTemplateError: null,
      };

    case TEMPLATE_CREATE_MAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        createMailTemplatePending: false,
        createMailTemplateError: action.data.error,
      };

    case TEMPLATE_CREATE_MAIL_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        createMailTemplateError: null,
      };

    default:
      return state;
  }
}
